//Assessment components
import FormulaBuilderDragIcon from "../FormulaBuilderDragIcon"
import formulaBuilderTypes from "../formulaBuilderTypes"

//PrimeReact
import { Tooltip } from "primereact/tooltip"

//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

export default function RenderFormulaTag({ functionItem }) {
  const tooltipTarget = `tt-${functionItem.name}`

  return (
    <div className={`${myStyles.container}`}>
      <Tooltip
        target={`.${tooltipTarget}`}
        className={myStyles.functionToolTip}
      />
      <div className={myStyles.functionItemLayout}>
        <div className={myStyles.functionItemLayoutTag}>
          <div className={`${myStyles.functionTag}`}>
            {functionItem.display}
          </div>
        </div>
        <div
          className={`${myStyles.functionItemLayoutInfo} ${tooltipTarget}`}
          data-pr-tooltip={functionItem.tooltip}
          data-pr-position="bottom"
        >
          <span className={`material-icons-outlined`}>{"info"}</span>
        </div>
        <div className={myStyles.functionItemLayoutIcon}>
          <FormulaBuilderDragIcon
            id={functionItem.name}
            type={formulaBuilderTypes.draggableTypes.function}
            object={functionItem}
          />
        </div>
      </div>
    </div>
  )
}
